<body>
<div class="wrapper">
  <div class="container">
    <div class="col-left">
      <div class="heading">{{ 'Sign In Failed' }}</div>
      <div class="error-panel">
        <span><a [href]="path">{{ path }}</a></span>
        @if (errorDescription) {
          <span>{{ errorDescription }}</span>
        } @else {
          <span>{{ error }} </span>
        }
        <span class="admin-error ">{{ 'Please contact your system administrator' }}</span>
      </div>
    </div>
    <div class="col-right">
      <img src="assets/images/png/robot.png" alt="Broken robot image">
    </div>
  </div>
</div>
</body>

